// 1. Load chapters (name, id) and pages (id, pagenum?) in ONE request
// 2. Load first chapter and its pages into dropdown by default
// 3. When chapter changes, load page 1 JSON and image as default
// 4. When page changes, change JSON and image

import React, { useEffect, useRef, useState } from "react";
import "./BookPageDropDown.css";
import ChapterDataService from "../../services/ChapterService";

import DropDownSelector from "../micro_components/DropDownSelector";

const BookPageDropDownV2 = ({
  bookId,
  setChapterVideoLink,
  setPageId,
  setPageSrc,
  setJsonData,
  setJsonPage,
  setCurrentPageIndex,
  jsonData,
  currentPageIndex,
  refreshListener,
  pageId,
  currentPages,
  setCurrentPages,
  chapters,
  setChapters,
  currentChapter,
  setCurrentChapter,
  currentChapterIndex,
  setCurrentChapterIndex,
}) => {
  // current page id
  const [currentPage, setCurrentPage] = useState();
  const chapterDropDownRef = useRef();
  const pageDropDownRef = useRef();

  // current page id
  // const [currentChapter, setCurrentChapter] = useState();

  // const [pages, setPages] = useState([]);

  // local JSON Data
  // const [jsonData, setjsonData] = useState(parentJsonData);

  // useEffect(() => {
  //   setjsonData(parentJsonData);
  // }, [parentJsonData]);

  const handleChapterSelect = (e) => {
    // console.log("e: ", e);
    //   e will be an id but a string

    let chapter_index;
    let chapter = chapters.find((x, i) => {
      chapter_index = i;
      return x.id === parseInt(e);
    });

    chapterDropDownRef.current?.blur();

    // console.log("chapter: ", chapter.name);
    //select chapter
    setCurrentChapter(chapter);

    setCurrentChapterIndex(chapter_index);

    //set chapter link
    setChapterVideoLink(chapter.videoLink);

    if (chapter.pages && chapter.pages.length > 0) {
      //set page images
      setPageSrc(
        `https://d24hdgytax3x03.cloudfront.net/${bookId}/pages/${chapter.pages[0].contentImageLink}`
      );

      //update pages and current page
      setCurrentPages(chapter.pages);
      setCurrentPage(chapter.pages[0]);

      //page id
      setPageId(chapter.pages[0].id);

      //page index
      setCurrentPageIndex(0);

      //create jsonData
      // createJsonData(chapter.pages);

      // ChapterDataService.getPageJson(bookId, chapter.pages[0])
      //   .then((response) => {
      //     // console.log("NEW PAGE: ", response.data);
      //     setJsonPage(response.data);
      //   })
      //   .catch((e) => {
      //     setJsonPage({});
      //   });

      ChapterDataService.getPageJSONFromDPIApi(chapter.pages[0].id)
        .then((response) => {
          console.log("NEW PAGE: ", response);
          setJsonPage(response);
        })
        .catch((e) => {
          setJsonPage({});
        });
    }

    if (!chapter.pages[0] || !chapter.pages[0].contentImageLink) {
      setPageSrc("");
    }
  };

  const handlePageSelect = (e) => {
    //   e will be an id but a string
    let index = 0;
    let page = currentPages.find((x, i) => {
      index = i;
      return x.id === parseInt(e);
    });

    pageDropDownRef.current?.blur();

    setCurrentPage(page);
    setPageId(page.id);

    setPageSrc(
      `https://d24hdgytax3x03.cloudfront.net/${bookId}/pages/${page.contentImageLink}`
    );

    setCurrentPageIndex(index);

    // console.log("setting json page: ", jsonData[index]);
    // setJsonPage(jsonData[index]);

    ChapterDataService.getPageJSONFromDPIApi(page.id)
      .then((response) => {
        console.log("NEW PAGE: ", response);
        setJsonPage(response);
      })
      .catch((e) => {
        setJsonPage({});
      });

    if (!page.contentImageLink) {
      setPageSrc("");
    }
  };

  //load chapters
  useEffect(() => {
    getData(0);
  }, [bookId]);

  const getData = (chapterIndex, pageIndex) => {
    console.log("GETTING DATA");
    ChapterDataService.getChaptersAndPagesInBook(bookId).then((response) => {
      // console.log("chapters and pages: ", response.data);
      //set chapter options
      setChapters(response.data);
      //set current chapter
      setCurrentChapter(response.data[chapterIndex]);
      //set page options
      if (response.data[0]) {
        if (response.data[0].videoLink) {
          //set videoLink
          setChapterVideoLink(response.data[0].videoLink);
        }

        if (response.data[0].pages) {
          setCurrentPages(response.data[0].pages);

          //create json data
          // createJsonData(response.data[0].pages);

          if (response.data[0].pages[0]) {
            //set current page
            setCurrentPage(response.data[0].pages[0]);
            //set current page src
            setPageSrc(
              `https://d24hdgytax3x03.cloudfront.net/${bookId}/pages/${response.data[0].pages[0].contentImageLink}`
            );
            //set page id
            setPageId(response?.data[0]?.pages[0]?.id);
            ChapterDataService.getPageJSONFromDPIApi(
              response.data[0].pages[0].id
            )
              .then((response) => {
                console.log("NEW PAGE: ", response);
                setJsonPage(response);
              })
              .catch((e) => {
                setJsonPage({});
              });
            // ChapterDataService.getPageJson(bookId, response.data[0].pages[0])
            //   .then((response) => {
            //     // console.log("NEW PAGE: ", response.data);
            //     setJsonPage(response.data);
            //   })
            //   .catch((e) => {
            //     setJsonPage({});
            //   });
          }
        }
      }
      // console.log("returned: ", jsonData.length);
      // setjsonData(jsonData);
    });
  };

  // const createJsonData = (pages) => {
  //   // console.log("creating json data with: ", pages);
  //   let newJsonData = [];

  //   for (let i = 0; i < pages.length; i++) {
  //     console.log(i, " ", pages[i].jsonLink);

  //     if (pages[i].jsonLink) {
  //       ChapterDataService.getPageJson(bookId, pages[i])
  //         .then((response) => {
  //           // console.log("json response: ", response.data);
  //           // let formattedJson = response.data;
  //           // formattedJson.page_number = pages[i].page_number;
  //           // newJsonData.splice(i, 0, response.data);
  //           jsonData[i] = response.data;
  //           // setJsonData(newJsonData);
  //         })
  //         .catch((e) => {
  //           // newJsonData.splice(i, 0, { rects: [], points: [] });
  //           // setJsonData(newJsonData);
  //           // console.log("error getting page: ", pages[i].id);
  //           jsonData[i] = {};
  //         });
  //     } else {
  //       // console.log("no json link");
  //       // // newJsonData.push({});
  //       // newJsonData.splice(i, 0, { rects: [], points: [] });
  //       // setJsonData(newJsonData);
  //       jsonData[i] = {};
  //     }
  //   }

  //   // console.log("newJSonData: ", newJsonData.length);
  // };

  useEffect(() => {
    // console.log("jsonData: ", jsonData);
    // console.log("current page index: ", currentPageIndex);
    // setJsonData(jsonData);
    // setJsonPage(jsonData[currentPageIndex]);
  }, [
    currentPageIndex,
    pageId,
    jsonData,
    refreshListener,
    // jsonData.length,
    setJsonPage,
  ]);

  // useEffect(() => {}, [pages]);

  //REFRESH
  useEffect(() => {
    // console.log("getting data...");
    getData(currentChapterIndex, currentPageIndex);
  }, [refreshListener]);

  return (
    <div className="book-page-drop-down">
      <div style={{ color: "white", marginRight: "0.5rem" }}>Chapter: </div>
      {chapters && currentChapter && (
        <div className="book-page-drop-down__individual">
          <DropDownSelector
            ref={chapterDropDownRef}
            data={chapters}
            value={currentChapter.id}
            onChange={handleChapterSelect}
          />{" "}
        </div>
      )}
      <div style={{ color: "white", margin: "0 .5rem 0 1rem" }}>Page: </div>
      <div className="book-page-drop-down__individual">
        {currentPages.length > 0 && currentPage && (
          <DropDownSelector
            ref={pageDropDownRef}
            data={currentPages}
            value={currentPage.id}
            onChange={handlePageSelect}
          />
        )}
      </div>
    </div>
  );
};

export default BookPageDropDownV2;
